var _path;
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z"
  }));
};
export default SvgArrowUp;